import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { EvmTrxDetailInfo } from '~/api/repository'
import { transactionDetailKey } from '~/api/service/query-keys.const'
import { TransactionActionModel } from '~/types/model/transaction.model'
import { ITokenType } from '~/types/token-type.type'
import { setComma } from '~/utils/numberFormat'

export const useFetchTransactionDetail = (trxHash: string) => {
  return useQuery([ ...transactionDetailKey, trxHash ], (): Promise<ViewTrxDetailInfo> => {
    return explorerApi.trxController.getTrxDetail({ 
      requestBody: {
        trxHash
      }
     }).then((res) => {
      return transactionDetailDto(res as EvmTrxDetailInfo)
    })
  })
}

export type ViewTrxDetailInfo = EvmTrxDetailInfo & {
  unixTimeStamp: string;
  gasUsed: string;
  gasUsedPer: string;
  gasPrice: string;
  gasLimit: string;
  value: string;
  transactionFee: string;
  burntFees: string;
  transactionAction: Array<TransactionActionModel>;
}

const transactionDetailDto = (transaction: EvmTrxDetailInfo): ViewTrxDetailInfo => {
  const transactionAction: Array<TransactionActionModel> = []
  if (transaction.E20TLI.length) {
    transaction.E20TLI.forEach(transfer => {
      transactionAction.push(new TransactionActionModel(transfer, ITokenType.ERC20))
    })
  }
  if (transaction.E721TLI.length) {
    transaction.E721TLI.forEach(transfer => {
      transactionAction.push(new TransactionActionModel(transfer, ITokenType.ERC721))
    })
  }
  if (transaction.E1155TLI.length) {
    transaction.E1155TLI.forEach(transfer => {
      transactionAction.push(new TransactionActionModel(transfer, ITokenType.ERC1155))
    })
  }

  return {
    ...transaction,
    unixTimeStamp: secondsToDate(transaction.UT),
    gasUsed: setComma(transaction.GU),
    gasUsedPer: setComma(transaction.GUP),
    gasPrice: setComma(transaction.GP),
    gasLimit: setComma(transaction.GL),
    value: setComma(transaction.VAL),
    transactionFee: setComma(transaction.TRXF),
    burntFees: setComma(transaction.BF),
    transactionAction,
  }
}